import {Injectable} from '@angular/core';
import {ExpressionState, Store as ExpressionStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {Expression} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {ExpressionQuery} from './query';
import { of } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ExpressionService extends EntityService<ExpressionStore, ExpressionState> {

  expressions$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new Expression(item))),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('expression.entityTitle'),
    fields: [
      FieldConfig.create({
        type: 'input',
        label: of('Kulcs'),
        inputType: 'text',
        name: 'title',
        filterable: false,
        editable: false,
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: of('Fordítás'),
        inputType: 'text',
        name: 'translation',
        listed: true,
        editable: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: ExpressionQuery,
    protected store: ExpressionStore) {
    super(store, Expression);
  }

  get resourceName(): string {
    return 'expression';
  }

}
